import React, { useEffect, useRef } from "react";
import { NumberInput } from "@mui/base/Unstable_NumberInput/NumberInput";
export const NumericTimeEntry = (props) => {
  const inputRef = useRef(null);
  const {isReadOnlyInput,value,...restProps} = props;
  useEffect(()=>{
    if(isReadOnlyInput) return;
    if(inputRef.current){
      
        const inputBox = inputRef.current.querySelector('.base-NumberInput-input');

        if(inputBox){
            inputBox.value = value;
        }
    }
  },[value,isReadOnlyInput])
  return <NumberInput   value={value} {...restProps} ref={inputRef}/>;
};
